const apiBaseUrl = process.env.REACT_APP_BE_BASEURL || '';

export const isStudentUnionThs = () => {
  return apiBaseUrl.includes('//ths-backend.');
};

export const isStudentUnionCsu = () => {
  return apiBaseUrl.includes('//csu-backend.');
};

export const useActiveStudentUnion = () => {
  const isThs = isStudentUnionThs();
  const isCsu = isStudentUnionCsu();
  let union = 'UNKNOWN';
  union = isThs ? 'THS' : 'CSU';

  return {
    isThs,
    isCsu,
    union,
  };
};
